<template>
  <el-container>
    <el-header>
      <div class="fullScreen" @click="fullscreen">
        <i :class="isFullscreen? 'iconfont icon-tuichuquanping':'iconfont icon-ln_quanping'"></i>
      </div>
    </el-header>
    <el-main>
      <left />
      <center />
      <right />
    </el-main>
  </el-container>
</template>
<script>
import left from "../components/Left";
import center from "../components/Center";
import right from "../components/Right";
import screenfull from "screenfull";
export default {
  components: {
    left,
    center,
    right
  },
  data() {
    return {
      isFullscreen: false
    };
  },
  created() {
    let that = this;
    window.onresize = function() {
      if (screenfull.isFullscreen) {
        that.isFullscreen = true;
      } else {
        that.isFullscreen = false;
      }
    };
  },
  methods: {
    fullscreen() {
      screenfull.toggle();
      this.isFullscreen = true;
    }
  }
};
</script>
<style lang="scss" scoped>
.el-container {
  width: 100%;
  height: 100%;
  background: url("../assets/bgIcon/bg.png") no-repeat;
  background-size: 100% 100%;
  position: relative;
  .el-header {
    padding: 0;
    height: 117px !important;
    background: url("../assets/bgIcon/header.png") no-repeat;
    background-size: 100% 100%;
    position: relative;
    box-sizing: border-box;
    -ms-flex-negative: 0;
    flex-shrink: 0;
  }
  .fullScreen {
    position: absolute;
    right: 50px;
    top: 10px;
    cursor: pointer;
    z-index: 3;
    i {
      font-size: 30px;
      color: #006eae;
    }
    // }
  }
  //
  .el-main {
    display: block;
    -webkit-box-flex: 1;
    -ms-flex: 1;
    flex: 1;
    -ms-flex-preferred-size: auto;
    flex-basis: auto;
    overflow: inherit;
    box-sizing: border-box;
    padding: 0 10px;
    position: relative;
  }
}
</style>